import type { FC } from "react";
import { DataLineChartTooltip } from "web_myplann/Portfolio/Components/DataLineChart/DataLineChartTooltip";
import { useMouseTouchPosition } from "web_myplann/Shared/Hooks/useMouseTouchPosition";

export const ChartTooltip: FC = () => {
	const pos = useMouseTouchPosition();

	return <DataLineChartTooltip pos={pos} />;
};
